import React from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { Handle, Position } from '@xyflow/react';
import { Avatar, Box, IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
    AddBox,
    IndeterminateCheckBox,
    PeopleAltOutlined
} from '@mui/icons-material';
import RemoveRedEye from '@mui/icons-material/RemoveRedEye';
import { cardColor } from 'managerialTree/colorVariant';

const CustomNode = ({ id, data }) => {
    const rawColor = cardColor[data.departmentName] || cardColor['Staff'];
    const theme = useTheme();
    const departmentColor = theme.palette.mode === 'dark'
        ? {
            background: rawColor.darkBackground || rawColor.background,
            border: rawColor.darkBorder || rawColor.border,
            toogle: rawColor.darkToogle || rawColor.toogle,
            view: rawColor.darkView || rawColor.view
        }
        : rawColor;

    return (
        <Card
            variant='outlined'
            sx={{
                width: 240,
                minHeight: 68,
                backgroundColor: departmentColor.background,
                p: 1,
                borderRadius: 2,
                boxShadow: 1,
                maxWidth: 300,
                border: 3,
                borderColor: departmentColor.border,
                position: 'relative'
            }}
        >
            <Handle type='target' position={Position.Top} style={{ background: departmentColor.border }} />
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    pb: 1,
                    gap: '8px'
                }}
            >
                {!data?.profilePicture && (
                    <Avatar sx={{ bgcolor: departmentColor.border }}>
                        {data?.firstname?.charAt(0).toUpperCase()}
                    </Avatar>
                )}
                <Box
                    sx={{
                        flexGrow: 1
                    }}
                >
                    <Typography variant='subtitle1' fontWeight={600} sx={{ color: 'text.primary' }}>
                        {data.firstname + ' ' + data.middlename + ' ' + data.lastname}
                    </Typography>
                    <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                        {data.designationName}
                    </Typography>
                </Box>
            </Box>
            {data.subordinates.length < 1 && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        pt: 1,
                        borderTop: 1,
                        borderColor: departmentColor.border
                    }}
                >
                    <IconButton
                        size='small'
                        sx={{
                            color: departmentColor.view
                        }}
                        onClick={() => data.onNodeClickHandler(id)}
                    >
                        <RemoveRedEye />
                    </IconButton>
                </Box>
            )}

            {data.subordinates.length > 0 && (
                <Box
                    sx={{
                        pt: 1,
                        borderTop: 1,
                        borderColor: departmentColor.border
                    }}
                >
                    {!data.expanded && (
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mb: 1
                            }}
                        >
                            {data.subordinates.map((subordinate, i) =>
                                i <= 10 && (
                                    <Avatar
                                        sx={{
                                            bgcolor: departmentColor.border,
                                            width: 24,
                                            height: 24,
                                            mr: '-10px',
                                            border: `3px solid ${departmentColor.background}`,
                                            fontSize: '14px'
                                        }}
                                        key={subordinate?.email}
                                    >
                                        {subordinate?.firstname?.charAt(0).toUpperCase()}
                                    </Avatar>
                                )
                            )}
                            {data.subordinates.length > 10 && (
                                <Typography
                                    variant='body2'
                                    color='text.secondary'
                                    sx={{
                                        ml: '10px'
                                    }}
                                >
                                    +
                                </Typography>
                            )}
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    ml: 'auto'
                                }}
                            >
                                <PeopleAltOutlined sx={{ color: departmentColor.border }} />
                                <Typography variant='body2' sx={{ color: departmentColor.border }}>
                                    {data.subordinates.length}
                                </Typography>
                            </Box>
                        </Box>
                    )}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end'
                        }}
                    >
                        <IconButton
                            size='small'
                            sx={{
                                color: departmentColor.toogle
                            }}
                            onClick={() => data.onToggleExpand(id)}
                        >
                            {data.expanded ? (
                                data?.reportingManager !== 'null' && (
                                    <IndeterminateCheckBox />
                                )
                            ) : (
                                <AddBox />
                            )}
                        </IconButton>
                        <IconButton
                            size='small'
                            sx={{
                                color: departmentColor.view
                            }}
                            onClick={() => data.onNodeClickHandler(id)}
                        >
                            <RemoveRedEye />
                        </IconButton>
                    </Box>
                </Box>
            )}

            {data.subordinates.length > 0 && (
                <Handle type='source' position={Position.Bottom} style={{ background: departmentColor.border }} />
            )}
        </Card>
    );
};

// export default CustomNode;
export default React.memo(CustomNode);
